import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const ConnectorUIContext = createContext(null);
export function ConnectorUIProvider({ value, children, }) {
    return _jsx(ConnectorUIContext.Provider, { value: value, children: children });
}
export function useConnectorUI() {
    const ctx = useContext(ConnectorUIContext);
    if (!ctx) {
        throw new Error("useConnectorUI must be used within a <ConnectorUIProvider>");
    }
    return ctx;
}
//# sourceMappingURL=adapter.js.map